<template>
  <div v-on="$listeners"
       :class="colorClasses.root"
       class="tw-rounded tw-inline-grid tw-gap-3 hover:tw-transform hover:tw-shadow-lg tw-shadow tw-cursor-pointer tw-transition tw-overflow-hidden tw-p-5 hover:tw-scale-100.5 tw-transform-enhanced">
    <div class="tw-font-bold tw-text-lg tw-col-start-1 tw-col-end-3">{{ name }}
    </div>
    <div :class="colorClasses.price"
         class="tw-font-bold tw-row-start-2 tw-row-end-3 tw-justify-self-end tw-self-end tw-col-start-2 tw-col-end-3"
         style="font-size: 22px;">
      <font-awesome-icon :icon="active ? 'shopping-cart' : 'cart-plus'" />
      {{ pricingOption.price | displayPrice }}
    </div>
    <button
        v-if="hasTerms"
        :class="colorClasses.termsButton"
        @click.stop="openTerms"
            class="tw-rounded tw-inline-flex tw-self-end tw-justify-self-start tw-col-start-1 tw-col-end-2 tw-items-center tw-text-white tw-py-2 tw-px-2.5">
      Terms
      <font-awesome-icon class="tw-ml-2" icon="info-circle" />
    </button>
  </div>
</template>
<script>

export default {
  props: {
    pricingOption: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openTerms() {
      this.$modal.show("soundkit-terms", { pricingOption: this.pricingOption });
    }
  },
  computed: {
    hasTerms() {
      return !!this.pricingOption.agreement
    },
    name() {
      return this.pricingOption.pricingTemplateOption?.name ?? ''
    },
    colorClasses() {
      return {
        root: this.active ? [
          "tw-bg-infinity-license-highlight-gradient tw-text-infinity-license-highlight-contrast"
        ] : [
          "tw-bg-infinity-license-box-background-faded tw-text-infinity-license-box-text"
        ],
        price: this.active ? [
          "tw-text-infinity-license-highlight-contrast"
        ] : [
          "tw-text-infinity-license-button-background"
        ],
        termsButton: [
          "tw-text-infinity-license-button-text tw-bg-infinity-license-button-background tw-border-none",
          !this.hasTerms ? "tw-opacity-25" : "hover:tw-shadow"
        ]
      };
    }
  }
};
</script>
